// Croqui: `components/Card.tsx`.
//
// WEB-133: o cartão do kit desenha DOIS papéis com as mesmas chamadas:
//  - solto na página, é o cartão do sistema (`ui/card.tsx`): `bg-card`, raio 20 e o fio de
//    1px (`--shadow-card`);
//  - dentro de uma superfície (`Panel`, gaveta, diálogo, popover, `Card` de `ui/`: todos
//    marcam `data-surface`), é a CÉLULA interna: `bg-secondary`, raio 12, sem fio. Cartão
//    dentro de cartão com dois fios era o que mais dava cara de kit antigo.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';

/** Cartão (ou célula, dentro de um `Panel`). `active` marca a seleção com um fio de tinta. */
export function Card({
  children,
  active = false,
  className,
}: {
  children: ReactNode;
  active?: boolean;
  className?: string;
}) {
  return (
    <div
      data-kit-card=""
      className={cn(
        // `--panel-pad: 0px`: uma tabela aqui dentro não sangra até a borda do `Panel` de fora.
        'min-w-0 rounded-2xl bg-card p-6 shadow-(--shadow-card) [--panel-pad:0px] in-data-surface:rounded-lg in-data-surface:bg-secondary in-data-surface:shadow-none',
        active &&
          'shadow-[inset_0_0_0_1.5px_var(--foreground)] in-data-surface:shadow-[inset_0_0_0_1.5px_var(--foreground)]',
        className,
      )}
    >
      {children}
    </div>
  );
}
